var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bouton openSans font-bold white",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-arrow-right"})])}]

export { render, staticRenderFns }